/*
调用方法handleParameter，传入对象
handleParameter({
    trackKey: 'service_service_click_service_type',
    attr: {
        service_type: name,
    },
});
标签上添加v-track指令，
trackKey： 事件英文名（应用英文名已拼接，不需要再写，模块_页面/资源_组件/动作的英文名，如：appointment_board_click_schedule）
attr：默认添加属性为：用户ID，账号类型（内外部账号），进入的店铺ID；
如不需要其他属性，则不传，需要在attr中添加。
*/
import sensors from 'sa-sdk-javascript';
import store from '../store';

export default function handleParameter(objs) {
    const { userInfo } = store.state.user;
    // 事件的属性
    let attrs = {
        xyt_id: userInfo.id,
        account_type: userInfo.userCategory,
        shop_id: userInfo.mode === 2 ? 'stores' : userInfo.lastLoginOrgId,
    };
    if (objs.attr) {
        const handleParameterAttrs = {};
        Object.keys(objs.attr).forEach((key) => {
            const str = key.replace(/([A-Z])/g, '_$1').toLowerCase();
            handleParameterAttrs[str] = objs.attr[key] || null;
        });
        attrs = {
            ...attrs,
            // ...JSON.parse(JSON.stringify(objs.attr)),
            ...handleParameterAttrs,
        };
    }
    // 事件英文名
    const name = `xytsaas_${objs.trackKey}`;
    sensors.track(name, {
        ...attrs,
    });
}
